<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card flat>
    <v-card-text>
      <v-flex d-flex>
        <v-text-field
            v-model="generalSearch"
            label="Grup Rehber Kaydı Filtrele"
            @input="searchContact"
            @click:append="searchContact"
            append-icon="search">
        </v-text-field>
      </v-flex>

      <v-btn
          color="primary"
          dark
          @click="excelFn({ name: groupName, id })">
        Excel'e Aktar
      </v-btn>

      <v-data-table
          v-model="selected"
          :headers="contactsHeaders"
          :page.sync="pagination.current"
          :items="filteredData"
          hide-default-footer
          item-key="id"
          show-select
          class="elevation-1">
        <template v-slot:footer>
          <td class="d-flex justify-end">
            <v-btn
                text
                color="red"
                class="my-3 mx-1"
                @click="deleteBulk"
            >
              <v-icon medium>
                delete
              </v-icon>
              Seçili Kişileri Sil
            </v-btn>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  class="mr-2"
                  @click="detailGroup(item.id)">
                edit
              </v-icon>
            </template>
            <span>Kayıt Bilgilerini Güncelle</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="deleteGroup(item.id)">
                delete
              </v-icon>
            </template>
            <span>Kaydı Sil</span>
          </v-tooltip>
        </template>
        <no-data-available/>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <pagination
            :pagination="pagination"
            :action="onPagination">
        </pagination>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import NoDataAvailable from '../NoDataAvailable.vue';
import Pagination from '../Pagination.vue';

export default {
  components: { Pagination, NoDataAvailable },
  props: ['id', 'excelFn', 'groupName'],
  data: () => ({
    generalSearch: '',
    route: '',
    contactsHeaders: [
      {
        text: 'Ad',
        align: 'left',
        value: 'name',
      },
      { text: 'Soyad', value: 'surname' },
      { text: 'Telefon Numarası', value: 'phone' },
      {
        text: 'İşlemler', value: 'actions', align: 'right', searchable: false,
      },
    ],
    pagination: {
      current: 1,
      total: 0,
    },
    searchResults: [],
    contacts: [],
    selected: [],
  }),
  computed: {
    ...mapFields(['freeZone']),
    filteredData() {
      if (this.generalSearch !== '' && this.searchResults.length > 0) {
        return this.searchResults;
      }
      return this.contacts;
    },
  },
  watch: {
    generalSearch(nv) {
      if (nv === '') {
        this.searchResults = [];
      }
    },
  },
  created() {
    this.onLoad();
  },
  methods: {
    ...mapActions({
      send: 'sendBackend',
      sendAsync: 'asyncSender',
    }),
    searchContact() {
      if (this.generalSearch.length >= 3) {
        const data = {
          group_id: this.id,
          value: this.generalSearch,
        };
        this.send({ route: 'search/contact', data })
            .then((res) => {
              this.searchResults = res.data.data.data;
              this.pagination.current = res.data.data.current_page;
              this.pagination.total = res.data.data.last_page;
            });
      }

      if(this.generalSearch.length === 0)
        this.onLoad();
    },
    async deleteBulk() {
      if (this.selected.length > 0) {
        // Seçili olanlar obje olarak kaydedildiği için,
        // bu aşamada yanlızca id'lerini alıyorum.
        this.selected = this.selected.map(a => a.id);

        this.deleteGroup(this.selected)
            .then(async () => {
              this.onPagination();
            });
      }
    },
    async deleteGroup(id) {
      return new Promise((resolve) => {
        this.$store.commit('fireConfirmation', async () => {
          const route = 'delete/contacts';
          const data = { id: Array.isArray(id) ? id : [id] };

          this.send({ route, data })
              .then(() => {
                this.contacts = Array.isArray(id)
                    ? this.contacts.filter(obj => !this.selected.includes(obj.id))
                    : this.contacts.filter(obj => obj.id !== id);
              });
          resolve();
        });
      });
    },
    detailGroup(id) {
      this.$router.push({ name: 'contact.detail', params: { id } });
    },
    onLoad(route = null, sendData = null) {
      this.route = route || 'details/group';
      const data = sendData || { id: this.id };

      this.send({ route: this.route, data })
          .then((res) => {
            this.contacts = res.data.data.contacts.data;
            this.pagination.current = res.data.data.contacts.current_page;
            this.pagination.total = res.data.data.contacts.last_page;
          });
    },
    onSearching(route) {
      const data = { group_id: this.id,value:this.generalSearch };

      this.send({ route, data })
          .then((res) => {
            this.searchResults = res.data.data.data;
            this.pagination.current = res.data.data.current_page;
            this.pagination.total = res.data.data.last_page;
          });
    },
    onPagination() {
      if(this.generalSearch.length >= 3)
        this.onSearching(`search/contact?page=${this.pagination.current}`)
      else
        this.onLoad(`details/group?page=${this.pagination.current}`);
    },
  },
};
</script>
